import React, { Component } from "react";
import { browserHistory } from "react-router";
import { Link } from "react-router";
import PropTypes from "prop-types";
import DatePicker from "react-datepicker";
import ScheduleByTimeslotButtons from "./schedule-by-timeslot-buttons";
import ScheduleByTimeslotJump from "./schedule-by-timeslot-jump";
import ScheduleByTimeslotSchedule from "./schedule-by-timeslot-schedule";
import moment from "moment";
import util from "../util/util";

const jQuery = window.jQuery;

export default class ScheduleByTimeslot extends Component {
  constructor(props) {
    super(props);

    this.state = this.returnInitialState(props);
  }

  componentDidMount() {
    this.mounted = true;

    this.getInterstitialsByTimeslot(this.state.dynamicDay, true);
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  componentWillReceiveProps(nextProps) {
    const callback = () => {
      this.getInterstitialsByTimeslot(this.state.dynamicDay, true);
    };

    this.setState(this.returnInitialState(nextProps), callback);
  }

  render() {
    return (
      <div className="schedule-by-timeslot">
        <div className="row">
          <div className="col-sm-4 col-sm-push-8">
            <p className="page__actions page__actions--stacked">
              <Link
                className="btn btn-default"
                to={util.returnScheduleDayUrl(this.state.urlDay)}
              >
                <i className="fa fa-arrow-up" aria-hidden="true"></i>
                Return to daily schedule
              </Link>
            </p>
          </div>
          <div className="col-sm-8 col-sm-pull-4">
            <h4 className="page__title">Time Slot Schedule</h4>
          </div>
        </div>

        <hr />

        <ScheduleByTimeslotButtons
          day={this.state.urlDay}
          loaded={this.state.loaded}
          timeslot={this.state.timeslot}
        />

        <hr />

        <ScheduleByTimeslotSchedule schedule={this.state.schedule} />

        <div className="schedule-by-timeslot__actions text-center">
          <button
            type="button"
            className="btn btn-default btn--loadmore"
            data-loading-text="<i class='fa fa-spinner fa-spin'></i> <i class='fa fa-calendar-plus-o'></i> Loading More Dates"
            onClick={() => this.loadMore()}
          >
            <i className="fa fa-calendar-plus-o" aria-hidden="true"></i>
            Load More Dates
          </button>

          <DatePicker
            customInput={<ScheduleByTimeslotJump />}
            selected={moment(this.state.urlDay)}
            startDate={moment(this.state.urlDay)}
            endDate={moment(this.state.dynamicDay).add(
              util.daysPerTimeSlotPerPage - 1,
              `days`
            )}
            onChange={value => {
              const newStartDate = value.format(util.dateFormatComputer);
              const newUrl = util.returnScheduleTimeSlotUrl(
                this.state.timeslot,
                newStartDate
              );

              browserHistory.push(newUrl);
            }}
          />
        </div>
      </div>
    );
  }

  // use the same logic to set state (on load, on prop change);
  returnInitialState(props = {}) {
    const day = props.params.day || moment().format(util.dateFormatComputer);

    return {
      loaded: false, // is the schedule data ready to be displayed;
      schedule: this.generateEmptySchedule(day), // create an empty schedule array;
      urlDay: day, // record the original day for a link back to the daily schedule;
      dynamicDay: day, // display date for Date Picker;
      timeslot: props.params.timeslot || util.timeSlots[0] // timeslot to display schedule data for;
    };
  }

  // convert a date into a new date (and format);
  returnDay(date, daysToChange) {
    return moment(date)
      .add(daysToChange, `days`)
      .format(util.dateFormatComputer);
  }

  // returns an empty schedule we can now use;
  // insert Ajax content into it, or display as-is (on prop change);
  generateEmptySchedule(startDate) {
    const schedule = [];

    // loop through the next X days;
    for (let i = 0; i < util.daysPerTimeSlotPerPage; i = i + 1) {
      schedule.push({
        date: this.returnDay(startDate, i),
        pod: null,
        rule: null
      });
    }

    return schedule;
  }

  // get the schedule data to display;
  getInterstitialsByTimeslot(startDate, overwrite = false) {
    util
      .getInterstitialsByTimeslot(
        this.state.timeslot,
        startDate,
        util.daysPerTimeSlotPerPage
      )
      .then(data => {
        setTimeout(() => {
          const schedule = this.generateEmptySchedule(startDate);

          data.forEach(interstitial => {
            const date = moment(interstitial.airtime).format(
              util.dateFormatComputer
            );

            let index = null;

            // find the timeslot (if it exists);
            schedule.forEach((day, i) => {
              if (day.date === date) {
                index = i;
              }
            });

            // if a timeslot was found;
            if (index !== null) {
              // add the content to the timeslot;
              schedule[index].pod = interstitial.pod;
              schedule[index].rule = interstitial.rule;
            }
          });

          // only overwrite on init and propchage;
          const newSchedule = overwrite
            ? schedule
            : this.state.schedule.concat(schedule);

          this.mounted &&
            this.setState(
              {
                loaded: true,
                schedule: newSchedule
              },
              () => {
                // reset the button in case it's in a loading state;
                jQuery(`.btn--loadmore`).button(`reset`);
              }
            );
        }, util.delayList);
      });
  }

  // append more schedule data to the existing schedule;
  loadMore() {
    // put the button into a processing state;
    jQuery(`.btn--loadmore`).button(`loading`);

    this.setState(
      {
        dynamicDay: this.returnDay(
          this.state.dynamicDay,
          util.daysPerTimeSlotPerPage
        )
      },
      () => {
        this.getInterstitialsByTimeslot(this.state.dynamicDay);
      }
    );
  }
}

ScheduleByTimeslot.propTypes = {
  params: PropTypes.object
};
